import { render, staticRenderFns } from "./NsMinimalHeaderRegionSelector.vue?vue&type=template&id=71ab77b2&scoped=true&"
import script from "./NsMinimalHeaderRegionSelector.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderRegionSelector.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderRegionSelector.vue?vue&type=style&index=0&id=71ab77b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab77b2",
  null
  
)

export default component.exports